import { render } from "./AdminSettings.vue?vue&type=template&id=ebdd1552&scoped=true"
import script from "./AdminSettings.vue?vue&type=script&lang=js"
export * from "./AdminSettings.vue?vue&type=script&lang=js"

import "./AdminSettings.vue?vue&type=style&index=0&id=ebdd1552&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebdd1552"]])

export default __exports__